<div class="container-fluid">
  <div class="row">
    <div class="col-lg-4 col-md-6 col-sm-12">
      <app-eca-input label="Training Contact Name"  [controlId]="'ctrlTrainingContactName'"
                     [isReadOnly]="!editing"
                     popoverText="You can add a contact name that is the point of contact for training and compliance based information"
                     [(value)]="company.contactName">
      </app-eca-input>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <app-eca-input label="Contact Email" [inputType]="'email'"  [controlId]="'ctrlTrainingContactEmail'"
                     [isValid]="validateEmail(company.contactEmail)"
                     [isReadOnly]="!editing"
                     popoverText="You can add a contact email address that is the point of contact for training and compliance based information"
                     [(value)]="company.contactEmail">
      </app-eca-input>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <app-eca-input label="Contact Phone"  [controlId]="'ctrlTrainingContactPhone'"
                     [isReadOnly]="!editing"
                     popoverText="You can add a contact phone number that is the point of contact for training and compliance based information"
                     [(value)]="company.contactPhone">
      </app-eca-input>
    </div>
  </div>
  <div class="row">
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
      <app-eca-input label="Enterprise Name"  [controlId]="'ctrlCompanyName'"
                     [isRequired]="true"
                     [isReadOnly]="true"
                     [value]="company.companyName">
      </app-eca-input>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
      <app-eca-input label="Member/Reference Number"  [controlId]="'ctrlMemberReferenceNumber'"
                     [isRequired]="true"
                     [isReadOnly]="true"
                     [(value)]="company.referenceNumber">
      </app-eca-input>
    </div>

  </div>
  <div class="row">
    <div class="col-lg-4 col-md-6 col-sm-12">
      <app-eca-input label="Address Line 1"  [controlId]="'ctrlCompAddressLine1'"
                     [isRequired]="true"
                     [isReadOnly]="!editing || company.referenceNumber"
                     [(value)]="company.addressLine1">
      </app-eca-input>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <app-eca-input label="Address Line 2" [controlId]="'ctrlCompAddressLine2'"
                     [isRequired]="true"
                     [isReadOnly]="!editing || company.referenceNumber"
                     [(value)]="company.addressLine2">
      </app-eca-input>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <app-eca-input label="Address Line 3" [controlId]="'ctrlCompAddressLine3'"
                     [isRequired]="true"
                     [isReadOnly]="!editing || company.referenceNumber"
                     [(value)]="company.addressLine3">
      </app-eca-input>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-4 col-md-6 col-sm-12">
      <app-eca-input label="Town" [controlId]="'ctrlCompanyTown'"
                     [isRequired]="true"
                     [isReadOnly]="!editing || company.referenceNumber"
                     [(value)]="company.addressTown">
      </app-eca-input>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <app-eca-input label="County" [controlId]="'ctrlCompanyCounty'"
                     [isRequired]="true"
                     [isReadOnly]="!editing || company.referenceNumber"
                     [(value)]="company.addressCounty">
      </app-eca-input>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <app-eca-input label="Postcode" [controlId]="'ctrlCompanyPostCode'"
                     [isRequired]="true"
                     [isReadOnly]="!editing || company.referenceNumber"
                     [(value)]="company.addressPostcode">
      </app-eca-input>
    </div>
  </div>
</div>
